<template>
<div class="pb-50" v-if="user">
    <b-row>
        <b-col cols="12" md="12">
            <div class="panel-title">{{ $t('user.profil.myProfil') }}</div>
        </b-col>
    </b-row>
    <div class="tab-panel no-btm-border">
        <div class="tab-row">
            <div class="tab" :class="{'active': tab == 0}" @click="tab = 0">
                <div>{{ $t('user.profil.myInfo') }}</div>
            </div>
            <div class="tab" :class="{'active': tab == 1}" @click="tab = 1">
                <div>{{ $t('user.account.myAccount') }}</div>
            </div>
        </div>
    </div>
    <div v-if="tab == 0">
        <b-form ref="userForm" @submit="saveUser" @reset="resetUser">
            <div class="panel-body no-btm-border-body">
                <div class="card-body-data-1">
                    <b-row>
                        <b-col cols="12" md="4" class="frm-field i-pad-3">
                            <div>
                                <div class="field-title">Photo</div>
                                <div class="avtar-block">
                                    <b-avatar class="update-avtar" variant="info" :src="profilePicture"></b-avatar>
                                    <!-- <img class="add-one-img" :src="user.photo" /> -->
                                </div>
                              <file-upload extensions="gif,jpg,jpeg,png,webp" accept="image/png,image/gif,image/jpeg,image/webp" name="avatar" post-action="/upload/post" v-model="files" ref="upload" @input-filter="inputFilter" @input-file="inputFile">
                                <b-icon icon="plus-circle-fill" v-if="edit"></b-icon>
                              </file-upload>
                              
                              <b-modal ref="cropper" size="xl" hide-footer v-show="cropper" :title="$t('user.profil.ModalPictureTitle')">
                                  <div class="avatar-edit-image" v-if="files.length">
                                    <img ref="editImage" :src="files[0].url" style="max-width: 100%; max-height: 100%"/>
                                  </div>
                                <div class="ButtonGroup">
                                  <div class="mb-2">
                                    <b-button type="button" class="Button ButtonDenied" block @click="editCancel">{{ $t('global.cancel') }}</b-button>
                                  </div>
                                  <div class="mb-1">
                                    <b-button type="button" class="Button ButtonAccept" block @click="editSave">{{ $t('global.save') }}</b-button>
                                  </div>
                                </div>
                              </b-modal>
                              
                            </div>
                            <!-- <div class="profile-btn-text-area">
                                <div class="field-title">{{ $t('user.profil.bio') }}</div>
                                <div class="field-block">
                                    <b-form-textarea type="text" class="cust-textarea" placeholder="" rows="8"></b-form-textarea>
                                </div>
                            </div> -->
                        </b-col>
                        <b-col cols="12" md="4" class="frm-field i-pad-3">
                            <div>
                                <div class="field-title">{{ $t('user.profil.lastName') }}<span v-if="edit">*</span></div>
                                <div class="field-block">
                                    <b-form-input type="text" class="cust-input" :placeholder="$t('user.profil.lastName')" v-model="user.lastName" :disabled="!edit" required></b-form-input>
                                </div>
                            </div>
                            <div>
                                <div class="field-title">{{ $t('user.profil.firstName') }}<span v-if="edit">*</span></div>
                                <div class="field-block">
                                    <b-form-input type="text" class="cust-input" :placeholder="$t('user.profil.firstName')" v-model="user.firstName" :disabled="!edit" required></b-form-input>
                                </div>
                            </div>
                            <div>
                                <div class="field-title">{{ $t('user.profil.displayName') }}<span v-if="edit">*</span></div>
                                <div class="field-block">
                                    <b-form-input type="text" class="cust-input" :placeholder="$t('user.profil.displayName')" v-model="user.displayName" :disabled="!edit" required></b-form-input>
                                </div>
                            </div>
                            <div>
                                <div class="field-title">{{ $t('user.profil.birthday') }}<span v-if="edit">*</span></div>
                                <div class="field-block">
                                    <b-form-input type="date" class="cust-input" :placeholder="$t('user.profil.birthday')" v-model="user.birthday" :disabled="!edit" required></b-form-input>
                                </div>
                            </div>
                            <div>
                                <div class="field-title">{{ $t('user.profil.address') }}<span v-if="edit">*</span></div>
                                <div class="field-block">
                                    <b-form-textarea type="text" class="cust-input" rows="3" :placeholder="$t('user.profil.addressStruct')" v-model="user.address" :disabled="!edit" required></b-form-textarea>
                                </div>
                            </div>
                            <!-- <div class="s-last-input">
                                <div class="field-block">
                                    <b-form-input type="text" class="cust-input" :placeholder="$t('user.profil.city')" :disabled="!edit" required></b-form-input>
                                </div>
                            </div>
                            <div class="last-input">
                                <div class="field-block">
                                    <b-form-input type="text" class="cust-input" :placeholder="$t('user.profil.country')" :disabled="!edit" required></b-form-input>
                                </div>
                            </div> -->
                        </b-col>
                        <b-col cols="12" md="4" class="frm-field i-pad-3">
                            <div>
                                <div class="field-title">{{ $t('user.profil.gender') }}</div>
                                <div class="field-block" style="margin-bottom: 9px">
                                    <b-form-select class="cust-input custom-drop-down" :disabled="!edit" v-model="user.gender" :options="genders"></b-form-select>
                                </div>
                            </div>
                            <div>
                                <div class="field-title">{{ $t('user.profil.weight')}}</div>
                                <div class="field-block">
                                    <b-form-input type="number" step="0.01" class="cust-input" placeholder="65 kg" lazy-formatter :formatter="format2Digits" v-model="user.weight" :disabled="!edit" required></b-form-input>
                                </div>
                            </div>
                            <div>
                                <div class="field-title">{{ $t('user.profil.size') }}</div>
                                <div class="field-block">
                                    <b-form-input type="number" step="0.01" class="cust-input" placeholder="1,82" lazy-formatter :formatter="format2Digits" v-model="user.size" :disabled="!edit" required></b-form-input>
                                </div>
                            </div>
                            <div>
                                <div class="field-title">{{ $t('user.profil.licenceNumber') }}<span v-if="edit">*</span></div>
                                <div class="field-block">
                                    <b-form-input type="text" class="cust-input" placeholder="" v-model="user.licenceNumber" :disabled="!edit" required></b-form-input>
                                </div>
                            </div>
                            <div>
                                <div class="field-title">
                                    {{ $t('user.profil.ID') }}<span v-if="edit">*</span>
                                    <!--<img class="info-img" :src="require('@/assets/img/pageicon/info.png')" /> -->
                                    <b-icon class="icon-all" id="icon-info-1" icon="info-circle">
                                    </b-icon>
                                    <b-popover target="icon-info-1" triggers="hover" placement="righttop">
                                      <template #title>{{ $t('user.profil.ID') }}</template>
                                      {{ $t('user.profil.infoIDText') }}
                                   </b-popover>
                                </div>
                                <div class="field-block">
                                    <b-form-input type="text" class="cust-input" placeholder="FRAJJ26" v-model="user.sportIdentifier" :disabled="!edit" required></b-form-input>
                                </div>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12" style="min-height: 20px">
                            <div v-if="edit" class="TextLabelMention">
                                {{ $t('user.profil.requiredFieldsInfo') }}
                            </div>
                        </b-col>
                    </b-row>
                </div>
            </div>    
            <div class="btm-submit-block">    
                <b-button type="button" class="btm-submit-btn-ui" v-if="!edit" @click="edit=true">{{ $t('global.modify') }}</b-button>
            </div>
            <div class="btm-submit-block">
                <b-button type="reset" class="btm-submit-btn-ui" v-if="edit" >{{ $t('global.cancel') }}</b-button>
                <b-button type="submit" class="btm-submit-btn-ui active" v-if="edit">{{ $t('global.save') }}</b-button>
            </div>
        </b-form>
    </div>
    <div class="panel-body no-btm-border-body" v-if="tab == 1">
        <div class="card-body-data-1">
            <b-row>
                <b-col cols="12" md="4" class="frm-field i-pad-3">
                    <div>
                        <div class="field-title">{{ $t('user.account.membershipDate') }}</div>
                        <div class="field-block">
                            <b-form-input type="date" class="cust-input" placeholder="18/05/2021" v-model="user.registration" disabled readonly required></b-form-input>
                        </div>
                    </div>
                    <div>
                        <div class="field-title">{{ $t('user.account.subscription') }}</div>
                        <div class="field-block">
                            <b-form-input type="text" class="cust-input" value="Gratuit" disabled readonly required></b-form-input>
                        </div>
                    </div>
                    <div>
                        <div class="field-title">{{ $t('global.email') }}</div>
                        <div class="field-block">
                            <b-form-input type="text" class="cust-input" v-model="user.email" disabled readonly required></b-form-input>
                        </div>
                    </div>
                    <!-- <div class="connect-with-gmail upper-mb-gmail">
                        <img class="connect-gmail-img" :src="require('@/assets/img/pageicon/image1.png')" />
                        Connecté en tant que Armel Cout
                    </div> -->
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="12" md="12">
                    <div class="connect-with-gmail">
                        <div>
                            <b-button v-b-modal.profile-delete type="button" class="gray-btn-ui TextButtonWithIcon">
                                <!-- <img class="toxins-img" :src="require('@/assets/img/pageicon/toxins.png')" /> -->
                                <img src="@/assets/img/icons/Cracked_heart.svg" height="14px" width="14px">
                                <p>{{ $t('user.account.deleteAccount') }}</p>
                            </b-button>
                        </div>
                        <div>
                            <div class="Comme-text">
                                <p v-html="$t('user.account.deleteAccountText')" style="margin-bottom: 0"></p>
                            </div>
                        </div>
                    </div>
                </b-col>
            </b-row>
        </div>
    </div>
    
    <!-- modal -->
    <b-modal id="profile-delete" hide-header-close hide-footer centered :title="$t('user.account.deletePopup.title')">
        <div class="cust-body">
            <div class="modal-text">{{ $t('user.account.deletePopup.text1') }}</div>
            <div class="modal-text">{{ $t('user.account.deletePopup.text2') }}</div>
            <div class="modal-text">{{ $t('user.account.deletePopup.text3') }}</div>
        </div>
        <div class="btm-modal-block">
            <b-button type="button" class="gray-btn-ui" @click="deleteUser">
                <img class="toxins-img" :src="require('@/assets/img/pageicon/toxins.png')" />
                <div class="mes-exp">{{ $t('user.account.deletePopup.deleteAccount') }}</div>
            </b-button>
            <b-button type="button" class="btm-modal-btn-ui-blue" @click="$bvModal.hide('profile-delete')">
                <img class="toxins-img" :src="require('@/assets/img/pageicon/six.png')" />
                <div class="mes-exp">{{ $t('user.account.deletePopup.stay') }}</div>
            </b-button>
        </div>
    </b-modal>
</div>
</template>

<script>

import FileUpload from 'vue-upload-component';
import Cropper from 'cropperjs'
import fileStorageServices from '@/services/fileStorageServices';

export default {
  data() {
        return {
            user:null,
            profilePicture:'https://www.gravatar.com/avatar/default?s=200&r=pg&d=mm',
            edit:false,
            cropper:false,
            files: [],
            tab: 0,
            genders:[
                { value:"MALE",text:this.$t('user.profil.male') },
                { value:"FEMALE",text:this.$t('user.profil.female')}
            ]
        }
    },
    mounted() {
        this.initUserValues();
    },
    comments:{
      FileUpload,
    },
    methods:{
    
    
       showCropper(value) {
        
        this.$refs['cropper'].show()
        if (value) {
          this.$nextTick(function () {
            if (!this.$refs.editImage) {
              return
            }
            let cropper = new Cropper(this.$refs.editImage, {
              autoCropArea: 0.5,
              aspectRatio: 1/1,
            })
            this.cropper = cropper
          })
        } else {
          if (this.cropper) {
            this.cropper.destroy()
            this.cropper = false
          }
        }
      },
      editCancel() {
        this.$refs['cropper'].hide();
      },
       editSave() {
        let oldFile = this.files[0]
        let binStr = atob(this.cropper.getCroppedCanvas().toDataURL(oldFile.type).split(',')[1])
        let arr = new Uint8Array(binStr.length)
        for (let i = 0; i < binStr.length; i++) {
          arr[i] = binStr.charCodeAt(i)
        }
        let file = new File([arr], oldFile.name, { type: oldFile.type })
  
         // Delete previous profile picture
  
         // Add new profile picture
         const targetFilePath = 'profilePictures/'+this.user.id+'.'+oldFile.name.split('.').pop();
  
         // Add loader while uploading file
         fileStorageServices.uploadFile(file,targetFilePath,(progress)=>{
           //console.log("Progress : "+progress);
         },(error)=>{
           console.error(error);
         },(url)=>{
           //console.log('file url : '+url);
           this.user.photo = url;
           this.profilePicture = url;
         });
         this.$refs['cropper'].hide();
       },
      alert(message) {
        alert(message)
      },
      inputFile(newFile, oldFile, prevent) {
        

        if (newFile && !oldFile) {
           this.$nextTick(function () {
             this.showCropper(true)
             this.cropper = true
           })
         }
         if (!newFile && oldFile) {
           this.cropper = false
         }
      },
      inputFilter(newFile, oldFile, prevent) {
        if (newFile && !oldFile) {
          if (!/\.(gif|jpg|jpeg|png|webp)$/i.test(newFile.name)) {
            this.alert('Your choice is not a picture')
            return prevent()
          }
        }
        if (newFile && (!oldFile || newFile.file !== oldFile.file)) {
          newFile.url = ''
          let URL = window.URL || window.webkitURL
          if (URL && URL.createObjectURL) {
            newFile.url = URL.createObjectURL(newFile.file)
          }
        }
      },
      
    
    
        initUserValues(){
            const storeUser = this.$store.getters['Auth/user'];
            if(storeUser != null){
                this.user = {};
                Object.keys(storeUser).forEach(key=>{
                    this.user[key] = storeUser[key];
                })
            }
            this.user.registration = this.$moment(this.user.registration).format("YYYY-MM-DD");
            this.user.birthday = this.$moment(this.user.birthday).format("YYYY-MM-DD");
            this.user.address = this.unboxAddress(this.user.address);
            this.user.weight = this.format2Digits(this.user.weight);
            this.user.size = this.format2Digits(this.user.size);
            this.profilePicture = this.user.photo;
        },
        format2Digits(value){
            return Number(value).toFixed(2);
        },
        unboxAddress(value){
            return value.replaceAll('|','\n');
        },
        boxAddress(value){
            return value.replaceAll('\n','|');
        },
        resetUser(event){
            event.preventDefault();

            this.initUserValues();
            this.edit = false;
        },
        saveUser(event){
            event.preventDefault();

            this.user.registration = this.$moment(this.user.registration);
            this.user.birthday = this.$moment(this.user.birthday).valueOf();
            this.user.address = this.boxAddress(this.user.address);

            this.$store.dispatch('Auth/updateUser',this.user)
                .then((newValues)=>{
                    this.user.registration = this.$moment(this.user.registration).format("YYYY-MM-DD");
                    this.user.birthday = this.$moment(this.user.birthday).format("YYYY-MM-DD");
                    this.user.address = this.unboxAddress(this.user.address);
                    this.edit = false;
                })
                .catch((error)=>{
                    const wrapError = new Error('Failed to save user');
                    wrapError.internalError = error;
                    throw wrapError;
                })
        },
        deleteUser(){
            console.log('To be implement')
        }
    }
}
</script>

<style>
  @import "../../style/App.scss";
  @import "../../style/AppComposants.scss";
</style>
